const TrustSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-navy-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-gold-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2">100% Seguro</h3>
            <p className="text-navy-600 text-sm">Protegido pela LGPD</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-gold-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2">Nossa agilidade é nosso diferencial</h3>
            <p className="text-navy-600 text-sm">Aprovação rápida</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-gold-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-navy-900 mb-2">Sem Taxas Antecipadas</h3>
            <p className="text-navy-600 text-sm">Sem cobranças indevidas, desconto em folha</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
